<template>
  <div>
    <el-dialog title="选择供应商" width="75%" :append-to-body="true" :visible.sync="viewData.visible"
               :close-on-click-modal="false" v-loading="loading">
      <div class="user-settings">
        <div>
          <el-table :data="dataList" row-key="id" size="small" :header-cell-style="{background:'#f5f5f5'}"
                    style="width: 100%;" border>
            <el-table-column label="选择" width="50" align="center">
              <template slot-scope="scope">
                <el-radio v-model="currentFactor" :label="scope.row" @input="clickChange">{{ "" }}</el-radio>
              </template>
            </el-table-column>
            <el-table-column type="index" header-align="left" align="left" width="50" label="序号">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="rfqSupplierCode" header-align="center" align="left" min-width="100" label="供应商编码">
            </el-table-column>
            <el-table-column prop="rfqSupplierName" header-align="center" align="left" min-width="100" label="供应商名称">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="openPartSelect">
          选择零件
        </el-button>
        <el-button size="small" type="primary" @click="confirm()">
          确认
        </el-button>
      </span>
    </el-dialog>
    <rfq-part-select ref="partSelect" @selectParts="addPartsToMprForm" :basicFormData="basicFormData"></rfq-part-select>
  </div>
</template>

<script>
import RfqPartSelect from './rfq-part-select.vue';
import {
  USER_TYPE,
  SUPPLY_RFQ_STATUS_VALUE,
  SUPPLY_TYPE_VALUE,
  getSUPPLY_TYPE_VALUE,
  DIALOG_CLOSED_TYPE
} from '@/utils/const';
import {
  getPriceAgreementSupplierList
} from "@/controller/priceAgreement";
import {
  createRfqSupplierBatch
} from "@/controller/rfq";
import {
  updateSpotPrice
} from '@/controller/audit';
import {
  createSpotFQ
} from "@/controller/rfq";

export default {
  components: {
    RfqPartSelect
  },
  props: {
    basicFormData: Object,
  },
  data() {
    return {
      loading: false,
      viewData: {
        visible: false,
        width: ''
      },
      dialogFormVisible: false,
      dataForm: {
        partybCode: '',
        projectName: '',
        carType: '',
        validityOfContract: '',
        contractStartDate: '',
        contractEndDate: ''
      },
      mprForm: {
        id: '',
        supplierList: [],
        partList: [],
      },
      dataList: [],
      partList: [],
      selectPartList:[],
      rfqId: '',
      supplierList: [],
      ids: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      DIALOG_CLOSED_TYPE: DIALOG_CLOSED_TYPE,
      dataListLoading: false,
      dataListSelections: [],
      SUPPLY_RFQ_STATUS_VALUE: SUPPLY_RFQ_STATUS_VALUE,
      SUPPLY_TYPE_VALUE: SUPPLY_TYPE_VALUE,
      getSUPPLY_TYPE_VALUE: getSUPPLY_TYPE_VALUE,
      currentFactor: '', // 单选框的v-model值
    }
  },
  mounted() {
  },
  methods: {
    open() {
      this.viewData.visible = true;
      this.pageSize = 100;
      this.pageIndex = 1;
      // this.getDataList();
    },
    onClosed(params) {
      console.log(params);
      return;
    },
    cancel() {
      this.close();
    },
    close(option = DIALOG_CLOSED_TYPE.CLOSE) {
      if (!this.viewData.visible) {
        return;
      }

      this.onClosed({
        option,
        sender: this,
        data: "OK",
      });
      this.viewData.visible = false;
    },
    confirm() {
      console.log("this.supplierList====" + this.supplierList);
      if (this.supplierList.length == 0) {
        this.$message({
          message: '请选择一家供应商',
          type: 'warning'
        });
        return false;
      }else if(this.selectPartList == 0){
        this.$message({
          message: '请选择零件数据',
          type: 'warning'
        });
        return false;
      } else if (this.supplierList.length == 1) {
        this.mprForm.supplierList = this.supplierList;
        this.mprForm.id = this.rfqId;
        let params = this.mprForm;
        // 创建新的询价单
        createSpotFQ(params).then((data) => {
          if (data && data.code === "00") {
            // 改变原审批单状态
            updateSpotPrice({rfqId: this.rfqId});
            this.viewData.visible = false;
            this.currentFactor = '';
            this.selectPartList=[];
            this.supplierList=[];
            this.$emit('refreshDataList', this.supplierList);
          } else {
            this.$message.error(data.msg);
          }
        });
      }
    },
    init(supplierList, partList, rfqId) {
      this.viewData.visible = true;
      this.dataList = supplierList;
      this.partList = partList;
      this.rfqId = rfqId;
      console.log("进入后的供应商数据", this.dataList);
      this.dataListLoading = true;
      this.currentFactor = '';
    },
    openPartSelect() {
      this.$refs.partSelect.open(this.partList, this.rfqId);
    },
    addPartsToMprForm(parts) {
      this.selectPartList = [];
      this.selectPartList.push(...parts);
      this.mprForm.partList = this.selectPartList;
    },
    clickChange(row) {
      console.log('选择的数据', row); // 这个打印的就是选中的这一条数据
      this.supplierList[0] = row;
    },
  }
}
</script>

<style lang="scss">
.el-dialog__body {
  .org-dialog-form {
    width: 95%;
  }
}

.linetext {
  white-space: pre-line;
}

.el-table__body {
  tr.current-row > td {
    color: #fff;
    background-color: #409EFF !important;
  }
}

.fr {
  float: right;
}

.mt15 {
  margin-top: 15px;
}

.mb {
  margin-bottom: 15px;
}
</style>
